import { FormControl } from "@angular/forms";
import { FormArray } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CriarAspectosComponent } from "./../../vincular-tipo-cliente/criar-aspectos/criar-aspectos.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogConfirmComponent } from "./../dialog/dialog-confirm/dialog-confirm.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfigurarPastaServiceService } from "./../../configurar-pasta-service.service";
import { Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { v4 as uuidv4 } from "uuid";

@Component({
  selector: "app-cadastroAspectoPropriedade",
  templateUrl: "./cadastroAspectoPropriedade.component.html",
  styleUrls: ["./cadastroAspectoPropriedade.component.scss"],
})
export class CadastroAspectoPropriedadeComponent implements OnInit {
  isLinear = false;
  isLoading = true;
  clientId;
  propDisabled = true;
  selectedTabIndex = 0;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  formGlobalUnico: FormGroup;
  datasourceAspecto: FormGroup;
  public pontosDeAcesso = this.configPastaService.getDataPontoDeAcesso();
  public propForm: FormGroup;
  public idAspectoSaved;
  public tipoId: number;
  public modelos: any[] = [];
  public nomeFormatado;
  public nameTipo: string;
  propriedadeFormArray: FormArray;
  nomesDistintosString: string;
  idsTipos: number[] = [];
  types: any[] = [
    { value: "d:text", inputType: "text" },
    { value: "d:mltext", inputType: "text" },
    { value: "d:int", inputType: "number" },
    { value: "d:long", inputType: "number" },
    { value: "d:float", inputType: "number" },
    { value: "d:double", inputType: "number" },
    { value: "d:date", inputType: "date" },
    { value: "d:datetime", inputType: "date" },
    { value: "d:boolean", inputType: "boolean" },
  ];
  typeData = "text";
  listItems = [];
  public prefixModel: string;
  nodesByModel: any[];
  nodesFiltered = [];

  myForm: FormGroup;
  formGroups: any = {};

  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private configPastaService: ConfigurarPastaServiceService
  ) {
    this.route.params.subscribe(
      (params) => (this.clientId = params["clientId"])
    );
  }

  ngOnInit() {
    this.formGlobal();
    this.formAspecto();
    this.formPropriedade();
    this.listarModelos();

    // console.log(this.pontosDeAcesso);
    const nomesDistintos = this.pontosDeAcesso.reduce((nomes, ponto) => {
      nomes.add(ponto.namePontoDeAcesso);
      return nomes;
    }, new Set());

    this.nomesDistintosString = Array.from(nomesDistintos).join(', ');
    this.idsTipos = this.pontosDeAcesso.map((ponto) => ponto.nodeId);
    this.formGlobalUnico.get("nodesId").setValue(this.idsTipos);

    // console.log(this.formGroups as FormArray);
  }

  popularFormArrayProps() {
    let indice = 0;
    this.propriedadeFormArray = this.formGlobalUnico.get('propriedadeFormArray') as FormArray;
    this.pontosDeAcesso.forEach((item, index) => {
      // console.log(item);
      // console.log(index);
      let nameFormat = this.formatarNomePropriedadeInit(this.pontosDeAcesso[index].namePontoDeAcesso);
      // console.log(nameFormat)
      if (!this.formGroups[item.namePontoDeAcesso]) {
        this.formGroups[item.namePontoDeAcesso] = this._formBuilder.group({
          name: [this.prefixModel+":"+nameFormat, Validators.required],
          title: [this.pontosDeAcesso[index].namePontoDeAcesso, Validators.required],
          description: [this.pontosDeAcesso[index].namePontoDeAcesso],
          type: ["", Validators.required],
          mandatory: ["", Validators.required],
          defaultValue: [""],
          constraint: [""],
          newProperty: [true],
        });
        // console.log(this.formGroups);
        indice++;

        this.propriedadeFormArray.push(this.createItemPreenchido(this.pontosDeAcesso[index].namePontoDeAcesso, this.prefixModel));
      }
    });

    //this.formGlobalUnico.get("propriedadeFormArray").setValue(this.formGroups);
  }

  addItem(): void {
    this.propriedadeFormArray = this.formGlobalUnico.get('propriedadeFormArray') as FormArray;
    this.propriedadeFormArray.push(this.createItem());
  }

  formGlobal() {
    this.formGlobalUnico = this._formBuilder.group({
      nodesId: ["", Validators.required],
      // clienteId: [this.clientId, Validators.required],
      pontosAcesso: [this.pontosDeAcesso, Validators.required],
      aspectoForm: [],
      propriedadeFormArray: this._formBuilder.array([])

    });
  }

  createItem(): FormGroup {
    return this._formBuilder.group({
      name: ["", Validators.required],
      title: ["", Validators.required],
      description: [""],
      type: ["", Validators.required],
      mandatory: ["", Validators.required],
      defaultValue: [""],
      constraint: [""],
      newProperty: [true],
    });
  }

  createItemPreenchido(nome:string, prefix: string): FormGroup {
    let nameFormat = this.formatarNomePropriedadeInit(nome);
    return this._formBuilder.group({
      name: [{ value: prefix+":"+nameFormat, disabled: true }, Validators.required],
      title: [nome, Validators.required],
      description: [nome],
      type: ["", Validators.required],
      mandatory: ["", Validators.required],
      defaultValue: [""],
      constraint: [""],
      newProperty: [true],
    });
  }

  formAspecto() {
    this.datasourceAspecto = this._formBuilder.group({
      nome: [{ value: "", disabled: true }, Validators.required],
      modeloAlfresco: ["", Validators.required],
      tipoPrimario: [""],
      titulo: [{ value: "", disabled: true }, Validators.required],
      descricao: [""],
      isNovoTipo: [true],
      isContainer: [false],
      isAtivo: [true],
      isAspect: [true],
    });
  }

  formPropriedade() {
    this.propForm = this._formBuilder.group({
      name: ["", Validators.required],
      title: ["", Validators.required],
      description: [""],
      type: ["", Validators.required],
      mandatory: ["", Validators.required],
      defaultValue: [""],
      constraint: [""],
      newProperty: [true],
    });
  }

  addAspecto() {
    if (!this.datasourceAspecto.valid) {
      this.openSnackBar('Preencha os campos obrigatórios !', true);
    } else {
      this.propDisabled = false;
      this.selectedTabIndex = 1;
      this.popularFormArrayProps();
      this.datasourceAspecto.get('nome').enable();
      // console.log(this.datasourceAspecto.value);
      this.formGlobalUnico.get('aspectoForm').setValue(this.datasourceAspecto.value);
      this.datasourceAspecto.get('nome').disable();
    }
  }

  saveAll() {
    // console.log(this.formGlobalUnico.value);
    this.salvarAll();
  }

  listarModelos() {
    this.configPastaService.getModelosAlfresco().subscribe(
      (dados) => {
        dados.forEach((element) => {
          if (element.clientId == this.clientId) {
            this.modelos.push(element);
          }
          this.isLoading = false;
        });
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  keyFunc(e) {
    // console.log(e);
    this.formatarNomePropriedade(e);
  }

  formatarNomePropriedade(e) {
    const str = e.target.value;
    const wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " DOS ",
      " DAS ",
      " DE ",
      " DA ",
      " DO ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
    this.propForm.get("name").setValue(this.prefixModel + ":" + nameFormated);
  }

  formatarNomePropriedadeInit(e) {
    const str = e;
    const wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " DOS ",
      " DAS ",
      " DE ",
      " DA ",
      " DO ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
      return nameFormated;
    //this.propForm.get("name").setValue(this.prefixModel + ":" + nameFormated);
  }

  formatarNome(e) {
    const str = e.target.value;
    const wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " DOS ",
      " DAS ",
      " DE ",
      " DA ",
      " DO ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
    this.datasourceAspecto.get("nome").setValue(nameFormated);

    const valueModeloAlfresco =
      this.datasourceAspecto.get("modeloAlfresco").value;
    if (valueModeloAlfresco >= 1) {
      this.datasourceAspecto
        .get("nome")
        .setValue(this.prefixModel + ":" + nameFormated);
    } else {
      this.datasourceAspecto.get("nome").setValue(nameFormated);
    }
  }

  onModelSelectionChange() {
    const idModelo = this.datasourceAspecto.get("modeloAlfresco").value;
    this.listarNodesByModel(idModelo);
    this.modelos.forEach((element) => {
      if (element.id === idModelo) {
        this.prefixModel = element.prefix;
      }
    });

    this.datasourceAspecto.get("titulo").enable();
    // console.log(this.prefixModel);
  }

  onSearch(value: string, mode: string) {
    const filter = value.toLowerCase();

    switch (mode) {
      case "TIPOPRIMARIO":
        this.nodesFiltered = this.nodesByModel.filter((node) =>
          node.title.toLowerCase().startsWith(filter)
        );
        break;
      default:
        break;
    }
  }

  listarNodesByModel(modelId: number) {
    this.isLoading = true;
    this.configPastaService.getAspectByModelId(modelId).subscribe(
      (data) => {
        this.isLoading = false;
        this.nodesByModel = data;
        this.nodesFiltered = [...data];
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  focusOutFunc(e) {
    if (e) {
      const nome = this.propForm.get("name").value;
      this.buscarPropertyByName(nome);
    }
  }

  buscarPropertyByName(nome: String) {
    this.configPastaService.buscarPropertyByName(nome).subscribe(
      async (data) => {
        // console.log(await data);
        if (data.existe && !data.is_aspect) {
          // console.log(data.propriedade);
          this.confirmCreateAspect(this.tipoId, data.propriedade.id);
        } else if (data.existe && data.is_aspect) {
          // console.log(data.propriedade);
          this.confirmVincularAspect(
            this.tipoId,
            data.propriedade.id,
            data.node_dicionario
          );
        } else {
          console.warn("Nova propriedade");
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  confirmCreateAspect(tipoId: number, propId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Uma propriedade com esse nome já foi criada ! Deseja criar um aspecto para esta propriedade ?",
        from: "save-propertie-dialog.component.ts",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      // console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.openCriarAspecto(tipoId, propId);
        // alert(`Id do tipo = ${tipoId} | Id da propriedade = ${propId} | Escolheu criar o aspecto`);
      } else {
        this.idAspectoSaved = Number(tipoId);
      }
    });
  }

  openCriarAspecto(tipoId, propId) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(CriarAspectosComponent, {
      data: {
        tipoId: tipoId,
        propExistId: propId,
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data !== null) {
        this.idAspectoSaved = data;
        this.setPropInAspectAndAspectInType(Number(tipoId), propId, data);
      }
    });
  }

  setPropInAspectAndAspectInType(tipoId, propId, aspectId) {
    const body = {
      tipoId: tipoId,
      propId: propId,
      aspectoId: aspectId,
    };
    this.configPastaService.setPropInAspectAndAspectInType(body).subscribe(
      (data) => {
        // console.log(data);
        this.openSnackBar("Aspecto criado e vinculado !", false);
        this.router.navigate(["/configurar-tipo-cliente/", this.clientId]);
      },
      (error) => {
        this.openSnackBar("Erro !", true);
        console.error(error);
      }
    );
  }

  confirmVincularAspect(tipoId: number, propId: number, aspecto) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Uma propriedade com esse nome já foi criada e vinculada a um aspecto ! Deseja vincular o aspecto a este tipo ?",
        from: "save-propertie-dialog.component.ts_vincular",
        aspecto: aspecto,
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      // console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.setPropInAspect(aspecto.id, tipoId);
        // alert(`Id do tipo = ${tipoId} | Id da propriedade = ${propId} | Escolheu criar o aspecto`);
      } else {
        this.idAspectoSaved = Number(tipoId);
      }
    });
  }

  setPropInAspect(idAspect, idNode) {
    this.configPastaService.setPropInAspect(idAspect, idNode).subscribe(
      (data) => {
        // console.log(data);
        this.openSnackBar("Aspecto vinculado a este tipo !", false);
        this.router.navigate(["/configurar-tipo-cliente/", this.clientId]);
      },
      (error) => {
        this.openSnackBar("Erro !", true);
        console.error(error);
      }
    );
  }

  onChangeTypeData(typeSelected) {
    const obj = this.types.find((e) => e.value === typeSelected);
    this.typeData = obj.inputType;
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }

  get list() {
    return this.propForm.get("list") as FormArray;
  }

  onChangeConstraint(constraint, i) {
    // console.log(constraint);
    let formArrayProps = this.formGlobalUnico.get("propriedadeFormArray") as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;

    arrayIndex.addControl(
      "constraint",
      new FormControl("", Validators.required)
    );
    // console.log(formArrayProps.controls[i].value);
    if (constraint === "LIST") {
      arrayIndex.get("constraint").setValue("LIST");
      arrayIndex.removeControl("regex");
      arrayIndex.addControl("list", this._formBuilder.array([]));
    } else if (constraint === "REGEX") {
      arrayIndex.get("constraint").setValue("REGEX");
      arrayIndex.removeControl("list");
      this.listItems = [];
      arrayIndex.addControl(
        "regex",
        new FormControl("", Validators.required)
      );
    } else {
      // arrayIndex.get("constraint").setValue(null);
      arrayIndex.removeControl("list");
      this.listItems = [];
      arrayIndex.removeControl("regex");
      arrayIndex.removeControl("constraint");
    }
  }

  addItemList(i) {
    let formArrayProps = this.formGlobalUnico.get("propriedadeFormArray") as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;
    // console.log(arrayIndex);
    let list = arrayIndex.get("list") as FormArray;
    list.push(this._formBuilder.control(""));
  }

  // deleteItem(i, index) {
  //   if (index > 0) {
  //     this.list.removeAt(index);
  //   } else {
  //     this.openSnackBar("O primeiro item da lista é obrigatório !", true);
  //   }
  // }

  deleteItem(i, index) {
    let formArrayProps = this.formGlobalUnico.get("propriedadeFormArray") as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;
    let list = arrayIndex.get("list") as FormArray;
    if (index > 0) {
      list.removeAt(index);
    } else {
      this.openSnackBar("O primeiro item da lista é obrigatório !", true);
    }
  }

  removeForm(i) {
    this.propriedadeFormArray = this.formGlobalUnico.get('propriedadeFormArray') as FormArray;
    // this.propriedadeFormArray.push(this.createItem());
    if (i > 0) {
      this.propriedadeFormArray.removeAt(i);
    } else {
      this.openSnackBar('Não é permitido remover a primeira propriedade', true);
    }
  }

  salvarAll() {
    this.setConstraints();
    this.isLoading = true;
    this.configPastaService.salvarAspcetoPropriedades(this.formGlobalUnico.value).subscribe(
      (data) => {
        // console.log(data);
        this.isLoading = false;
        this.openSnackBar("Aspecto e propriedade(s) salvos com sucesso !", false);
        this.router.navigate(["/tabela-matriz/", this.clientId]);
      }, (error) => {
        console.error(error);
        this.openSnackBar("Erro ! " , true);
        this.isLoading = false;
      }
    )
  }

  setConstraints() {
    let formArrayProps = this.formGlobalUnico.get("propriedadeFormArray") as FormArray;

    const constraintNula: any = {
      expression: "",
      listaItens: "",
      type: "",
    };

    for (let i=0; i< formArrayProps.length ; i++) {
      let arrayIndex = formArrayProps.controls[i] as FormGroup;
      let constraint;
      if (arrayIndex.get("constraint")!=null) {
        switch (arrayIndex.get("constraint").value) {
          case "none":
            // console.log('none');
            break;
          case "LIST":
            constraint = { ...constraintNula };
            constraint.name = `${this.prefixModel}:LIST_${uuidv4()}`;
            constraint.expression = null;
            const listaItems = [];
            const lista: any[] = arrayIndex.value.list;
            lista.forEach((el) => {
              listaItems.push({ id: null, value: el });
            });
            constraint.listaItens = listaItems;
            constraint.type = "LIST";
            arrayIndex.get("constraint").setValue(constraint);
            break;
          case "REGEX":
            constraint = { ...constraintNula };
            constraint.name = `${this.prefixModel}:REGEX_${uuidv4()}`;
            constraint.expression = arrayIndex.get("regex").value;
            constraint.listaItens = null;
            constraint.type = "REGEX";
            arrayIndex.get("constraint").setValue(constraint);
            break;
        }
      }
      arrayIndex.get("name").enable();
      if (arrayIndex.get("constraint")!=null) {
        if (arrayIndex.get("constraint").value === "") {
          arrayIndex.removeControl("constraint");
        }
      }
    }
  }

  reset() {
    this.router.navigate(["/tabela-matriz/", this.clientId]);
  }

  voltar() {
    this.propDisabled = true;
    this.selectedTabIndex = 0;
  }

}




// WEBPACK FOOTER //
// /app/src/app/components/cadastroAspectoPropriedade/cadastroAspectoPropriedade.component.ts